import axios from 'axios'
import I18n from 'i18n'
import { API_HOST } from 'constants/apiHost'
import getDataHash from 'helpers/getDataHash'
import { createList } from 'components/Items/actions'
import {
    FETCH_SEND_EMAIL_SHOPPING_LIST_REQUEST,
    FETCH_SEND_EMAIL_SHOPPING_LIST_SUCCESS,
    FETCH_SEND_EMAIL_SHOPPING_LIST_ERROR
} from '../constants/actionTypes'


const isValidEmail = (emailAddress) => {
    // eslint-disable-next-line
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return re.test(emailAddress.toLowerCase())
}

// transforming data for BE
const getFormattedItems = (items) => {
    const formattedItems = []

    Object.keys(items).forEach(item => {
        formattedItems.push({
            description: items[item].name,
            note: items[item].note,
            sourceUrl: items[item].sourceUrl
        })
    })

    return formattedItems
}

export const fetchSendEmailShoppingList = () => (dispatch, getState) => {
    dispatch({
        type: FETCH_SEND_EMAIL_SHOPPING_LIST_REQUEST
    })

    const nextState = getState()
    const userId = nextState.app.userId
    const listId = nextState.items.listId
    const listName = nextState.items.listName
    const items = getFormattedItems(nextState.items.byId)
    const emailAddress = nextState.emailSubscriptionForm.emailAddress
    const captchaToken = nextState.appCaptcha.token
    const transferSource = nextState.configuration.deliveryChannel
    const language = nextState.app.language
    const partner = nextState.configuration.partner.name

    // email validation
    if (!emailAddress || !isValidEmail(emailAddress)) {
        dispatch({
            type: FETCH_SEND_EMAIL_SHOPPING_LIST_ERROR,
            errorMessage: I18n.t('invalidEmail')
        })

        return
    }

    const data = {
        userId,
        listId,
        listName,
        items,
        emailAddress,
        transferSource,
        language,
        partner
    }

    axios({
        method: 'post',
        url: `${API_HOST}/sendlisttoemail`,
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Signature-Hash': getDataHash(data),
            'ReCaptcha-Token': captchaToken
        },
        data
    })
    .then(() => {
        dispatch(createList())
        dispatch({
            type: FETCH_SEND_EMAIL_SHOPPING_LIST_SUCCESS
        })
    })
    .catch(error => {
        const errorMessage = error.response.data.errorType === 'EmailValidation'
            ? I18n.t('invalidEmail')
            : I18n.t('invalidCaptcha')

        dispatch({
            type: FETCH_SEND_EMAIL_SHOPPING_LIST_ERROR,
            errorMessage
        })
    })
}
